import { Box, Button, Stack, Table, TableBody, TableCell, TableContainer, TableHead, TableRow, Typography } from '@mui/material'
import React, { useEffect, useState } from 'react'
import * as sx from '../../../common/stylesInline/report_daily_branch'
import ReactHtmlTableToExcel from 'react-html-table-to-excel'
import { Item } from '../../../common/snippets'
import { detailedSubHeading } from './HisabConstant'
import { callAddFontRobotoBold } from '../../../common/font/Roboto-bold'
import { callAddFontRobotoMedium } from '../../../common/font/Roboto-Medium-normal'
import jsPDF from 'jspdf'
import autoTable from 'jspdf-autotable'
import moment from 'moment'
import { focusElemnt, navigation3 } from '../../../common/helper'

const DetailedReport = ({ tableData, vehicleNo, loginData, toDate, fromDate }) => {
  const [state, setState] = useState({
    generatePDF: false,
    load: false,
  })
  const { generatePDF, load } = { ...state }
  const [isPdfLoading, setIsPdfLoading] = useState(true)
  const [reportData, setReportData] = useState([])
  const currentDateTime = moment(window.getTime ? window.getTime() : new Date()).format('DD-MMM-YYYY HH:mm');
  useEffect(() => {
    if (tableData.length > 0) {
      setReportData(groupingData(tableData))
    } else {
      setReportData([])
    }
  }, [tableData])
  const groupingData = (data) => {
    const groupedData = data.reduce((result, item) => {
      const key = `${item.HisabNo}`
      if (!result[key]) {
        result[key] = []
      }
      result[key].push(item)
      return result
    }, {})
    let newData = [{ isTableHeader: true, colSpan: 6, value: 'Generate Hisab Report' }]
    Object.keys(groupedData).map((val) => {
      const updateData = groupedHisabNo(groupedData[val])
      newData = [...newData, ...updateData]
    })
    return newData
  }
  const groupedHisabNo = (data) => {
    let detailedData = []
    let totalRow = {
      TotalAmount: 0,
      TotalParcel: 0,
    }
    let lessCommision = 0
    data.forEach((obj) => {
      detailedData.push({ isDataRow: true, ...obj })
      totalRow = { TotalAmount: totalRow.TotalAmount + obj.Freight, TotalParcel: totalRow.TotalParcel + obj.Items }
      lessCommision += obj.PCT
    })
    return [
      {
        isSubHeading: true,
        isSubHeadingData: [
          { value: `Vehicle No :${vehicleNo?.VehicleNo}`, colSpan: 2, align: 'left' },
          { value: `Hisab / Voucher No : ${data[0]?.HisabNo}`, colSpan: 2, align: 'center' },
          { value: `Hisab / Voucher Date:${data[0]?.HisabDate}`, colSpan: 2, align: 'right' },
        ],
      },
      {
        isHeading: true,
        LRNo: 'LR No.',
        ChallanNo: 'Challan No.',
        ToStation: 'To Station',
        Items: 'No. of Parcel/Cover',
        Remarks: 'Remarks',
        Freight: 'Amount',
      },
      ...detailedData,
      { isTotalRow: true, colSpan: 3, value: 'TOTAL BOOKINGS', TotalParcel: totalRow.TotalParcel, Remarks: '-', TotalAmount: Math.round(totalRow.TotalAmount) },
      { isSubTotalRow: true, value: 'LESS COMISSION', colSpan: 5, Alltotal: Math.round(lessCommision), color: '#FF0000' },
      {
        isSubTotalRow: true,
        value: `NET OUTSTANDING- VEHICLE NO :${vehicleNo?.VehicleNo}, HISAB / VOUCHER NO :${data[0]?.HisabNo}`,
        colSpan: 5,
        Alltotal: Math.round(totalRow.TotalAmount) - Math.round(lessCommision),
        color: '#444',
      },

    ]
  }
  const SecontInsideRowContent = ({ item, index }) => {
    return item.isTableHeader ? (
      <TableRow key={`SH-${index}`}>
        <TableCell
          sx={{ backgroundColor: '#BFE1FF', fontSize: '14px', fontWeight: '700', borderBottom: '1px solid #aeaeae' }}
          key={`SHD-${index}`}
          colSpan={item.colSpan}
        >
          {item.value}
        </TableCell>
      </TableRow>
    ) : item.isSubHeading ? (
      <TableRow key={`SH-${index}`}>
        {item.isSubHeadingData.map((obj, index) => (
          <TableCell
            sx={{ backgroundColor: '#BFE1FF', fontSize: '14px', fontWeight: '700', borderBottom: '1px solid #aeaeae' }}
            key={`SHD-${index}`}
            colSpan={obj.colSpan}
            align={obj.align}
          >
            {obj.value}
          </TableCell>
        ))}
      </TableRow>
    ) : item.isDataRow ? (
      <TableRow key={`DR-${index}`}>
        <TableCell sx={{ textAlign: 'left', fontSize: '12px' }}>{item.LRNo}</TableCell>
        <TableCell sx={{ textAlign: 'left', fontSize: '12px' }}>{item.ChallanNo}</TableCell>
        <TableCell sx={{ textAlign: 'left', fontSize: '12px' }}>{item.ToStation}</TableCell>
        <TableCell sx={{ textAlign: 'right', fontSize: '12px' }}>{item.Items}</TableCell>
        <TableCell sx={{ textAlign: 'left', fontSize: '12px' }}>{item.Remarks}</TableCell>
        <TableCell sx={{ textAlign: 'right', fontSize: '12px' }}>{item.Freight}</TableCell>
      </TableRow>
    ) : item.isTotalRow ? (
      <TableRow key={`TR-${index}`}>
        <TableCell sx={{ backgroundColor: '#EEEEEE', fontSize: '12px', fontWeight: '700', textAlign: 'right' }} colSpan={item.colSpan}>
          {item.value}
        </TableCell>
        <TableCell sx={{ backgroundColor: '#EEEEEE', fontSize: '12px', fontWeight: '700', textAlign: 'right' }}>
          {item.TotalParcel}
        </TableCell>
        <TableCell sx={{ backgroundColor: '#EEEEEE', fontSize: '12px', fontWeight: '700', textAlign: 'left' }}>{item.Remarks}</TableCell>
        <TableCell sx={{ backgroundColor: '#EEEEEE', fontSize: '12px', fontWeight: '700', textAlign: 'right' }}>
          {item.TotalAmount}
        </TableCell>
      </TableRow>
    ) : item.isHeading ? (
      <TableRow key={`TTR-${index}`}>
        {detailedSubHeading.map((col) => (
          <TableCell
            align={col.align}
            sx={{ backgroundColor: '#DAEDFE', fontSize: '14px', fontWeight: '500', whiteSpace: 'pre', borderBottom: '1px solid #aeaeae' }}
            key={`th-${col.field}`}
          >
            {col.headerName}
          </TableCell>
        ))}
      </TableRow>
    ) : item.isSubTotalRow ? (
      <TableRow key={`TR-${index}`}>
        <TableCell
          sx={{ backgroundColor: '#EEEEEE', fontSize: '12px', fontWeight: '700', textAlign: 'right', color: item.color }}
          colSpan={item.colSpan}
        >
          {item.value}
        </TableCell>
        <TableCell sx={{ backgroundColor: '#EEEEEE', fontSize: '12px', fontWeight: '700', textAlign: 'right', color: item.color }}>
          {item.Alltotal}
        </TableCell>
      </TableRow>
    ) : null
  }
  const SecontInsideRowContentForExcel = ({ item, index, fontVal }) => {
    return item.isTableHeader ? (
      <TableRow key={`SH-${index}`}>
        <TableCell
          style={{ backgroundColor: '#BFE1FF', fontSize: fontVal, fontWeight: '700', borderBottom: '1px solid #aeaeae' }}
          key={`SHD-${index}`}
          colSpan={item.colSpan}
        >
          {item.value}
        </TableCell>
      </TableRow>
    ) : item.isSubHeading ? (
      <TableRow key={`SH-${index}`}>
        {item.isSubHeadingData.map((obj, index) => (
          <TableCell
            style={{ backgroundColor: '#BFE1FF', fontSize: fontVal, fontWeight: '700', borderBottom: '1px solid #aeaeae' }}
            key={`SHD-${index}`}
            colSpan={obj.colSpan}
            align={obj.align}
          >
            {obj.value}
          </TableCell>
        ))}
      </TableRow>
    ) : item.isDataRow ? (
      <TableRow key={`DR-${index}`}>
        <TableCell style={{ textAlign: 'left', fontSize: fontVal, whiteSpace: 'pre' }}>{item.lrNo}</TableCell>
        <TableCell style={{ textAlign: 'left', fontSize: fontVal, whiteSpace: 'pre' }}>{item.chalNo}</TableCell>
        <TableCell style={{ textAlign: 'left', fontSize: fontVal, whiteSpace: 'pre' }}>{item.station}</TableCell>
        <TableCell style={{ textAlign: 'right', fontSize: fontVal, whiteSpace: 'pre' }}>{item.parcel}</TableCell>
        <TableCell style={{ textAlign: 'left', fontSize: fontVal, whiteSpace: 'pre' }}>{item.remarks}</TableCell>
        <TableCell style={{ textAlign: 'right', fontSize: fontVal, whiteSpace: 'pre' }}>{item.amount}</TableCell>
      </TableRow>
    ) : item.isTotalRow ? (
      <TableRow key={`TR-${index}`}>
        <TableCell style={{ backgroundColor: '#EEEEEE', fontSize: fontVal, fontWeight: '700', textAlign: 'right' }} colSpan={item.colSpan}>
          {item.value}
        </TableCell>
        <TableCell style={{ backgroundColor: '#EEEEEE', fontSize: fontVal, fontWeight: '700', textAlign: 'right' }}>
          {item.TotalParcel}
        </TableCell>
        <TableCell style={{ backgroundColor: '#EEEEEE', fontSize: fontVal, fontWeight: '700', textAlign: 'left' }}>
          {item.Remarks}
        </TableCell>
        <TableCell style={{ backgroundColor: '#EEEEEE', fontSize: fontVal, fontWeight: '700', textAlign: 'right' }}>
          {item.TotalAmount}
        </TableCell>
      </TableRow>
    ) : item.isHeading ? (
      <TableRow key={`TTR-${index}`}>
        {detailedSubHeading.map((col) => (
          <TableCell
            style={{
              backgroundColor: '#DAEDFE',
              fontSize: fontVal,
              fontWeight: '600',
              borderBottom: '1px solid #aeaeae',
              textAlign: col.align,
            }}
            key={`th-${col.field}`}
          >
            {col.headerName}
          </TableCell>
        ))}
      </TableRow>
    ) : item.isSubTotalRow ? (
      <TableRow key={`TR-${index}`}>
        <TableCell
          style={{ backgroundColor: '#EEEEEE', fontSize: fontVal, fontWeight: '700', textAlign: 'right', color: item.color }}
          colSpan={item.colSpan}
        >
          {item.value}
        </TableCell>
        <TableCell style={{ backgroundColor: '#EEEEEE', fontSize: fontVal, fontWeight: '700', textAlign: 'right', color: item.color }}>
          {item.Alltotal}
        </TableCell>
      </TableRow>
    ) : null
  }
  const generatepdf = (isSave) => {
    setIsPdfLoading(false)
    setState({ ...state, load: true, generatePDF: true })
    jsPDF.API.events.push(['addFonts', callAddFontRobotoBold])
    jsPDF.API.events.push(['addFonts', callAddFontRobotoMedium])
    const HeaderColumn = [
      {
        headerName: 'Vehicle No.',
        exportHead: 'Vehicle No.',
        field: 'vehicleNo',
        xlCol: { dataType: 'string', dataFormatter: null },
      },
    ]
    const HeaderColumns = HeaderColumn.map((col) => {
      return { header: col.exportHead, dataKey: col.field, xlCol: col.xlCol }
    })
    const pdfColumns = detailedSubHeading.map((col) => {
      return { header: col.exportHead, dataKey: col.field, xlCol: col.xlCol }
    })
    const doc = new jsPDF({ orientation: 'p', format: [1080, 1528], unit: 'px' })
    doc.autoTableSetDefaults({
      headStyles: { fontSize: 6, width: 'auto', halign: 'right', fillColor: [30, 89, 167] },
    })
    var totalPagesExp = '{total_pages_count_string}'
    const jsPdfHeaderFooter = (data, userData, totalPagesExp) => {
      const doc = data.doc
      // Footer
      var pageSize = doc.internal.pageSize
      var pageHeight = pageSize.height ? pageSize.height : pageSize.getHeight()
      var pageWidth = pageSize.width ? pageSize.width : pageSize.getWidth()

      var str = 'Page : ' + doc.internal.getNumberOfPages()
      if (typeof doc.putTotalPages === 'function') {
        str = str + ' of ' + totalPagesExp
      }
      doc.setFontSize(16)
      doc.text(str, doc.internal.pageSize.width - data.settings.margin.left + 130, pageHeight - 5, 'right')
      doc.setFont('Roboto', 'bold')
      doc.text(`Report By : ${userData.strUserName} [ ${userData.strBranchName} ]`, 30, pageHeight - 5)
      doc.text(`Report Time : ${moment(new Date()).format('DD MMM YYYY, ddd, HH:mm')}`, doc.internal.pageSize.width / 2 - (doc.getStringUnitWidth(`Report Time : ${moment(new Date()).format('DD MMM YYYY, ddd, HH:mm')}`) * doc.internal.getFontSize()) / 2 + 90, pageHeight - 5)
    }
    const drawCell = (data) => {
      var rows = data.table.body
      rows.map((val) => {
        if (val.raw.isTableHeader) {
          val.cells[0].text = val.raw.value
          val.cells[0].colSpan = val.raw.colSpan
          val.cells[0].styles.halign = 'left'
          val.cells[0].styles.valign = 'middle'
        } else if (val.raw.isSubHeading) {
          if (val.raw.isSubHeadingData.length > 0) {
            let prevColSpan = 0
            val.raw.isSubHeadingData.map((obj) => {
              val.cells[prevColSpan].text = `${obj.value}`
              val.cells[prevColSpan].colSpan = obj.colSpan
              val.cells[prevColSpan].styles.font = 'Roboto'
              val.cells[prevColSpan].styles.halign = obj.align
              val.cells[prevColSpan].styles.valign = 'middle'
              prevColSpan += obj.colSpan
            })
          }
        } else if (val.raw.isTotalRow) {
          let prevColSpan = 0
          for (let key in val.raw) {
            if (key == 'value') {
              val.cells[prevColSpan].text = val.raw.value.toString()
              val.cells[prevColSpan].colSpan = val.raw.colSpan
              val.cells[prevColSpan].styles.halign = 'right'
              prevColSpan += val.raw.colSpan
            } else {
              if (key !== 'isTotalRow' && key !== 'colSpan') {
                val.cells[prevColSpan].text = val.raw[key].toString()
                prevColSpan += 1
              }
            }
          }
        } else if (val.raw.isSubTotalRow) {
          val.cells[0].text = val.raw.value
          val.cells[0].colSpan = val.raw.colSpan
          val.cells[0].styles.halign = 'right'
          val.cells[0].styles.valign = 'middle'
          val.cells[val.raw.colSpan].text = val.raw.Alltotal.toString()
        }
      })
    }
    doc.setProperties({
      title: `Item List.pdf`,
      subject: 'Report',
      author: 'Maven Tech Labs Pvt. Ltd.',
      keywords: 'maven tech, Cargo system, Receive',
      creator: 'MTLPL',
    })

    autoTable(doc, {
      margin: { top: 180, left: 30, right: 30, bottom: 40 },
      alternateRowStyles: {
        fillColor: [255, 255, 255],
      },
      columns: HeaderColumns,
      body: [{ vehicleNo: vehicleNo?.VehicleNo }],
      columnStyles: {
        0: {
          fontSize: 18,
          font: 'Roboto',
          valign: 'middle',
          minCellHeight: 24,
          halign: 'left',
          minCellHeight: 36,
          cellPadding: 12,
          fontStyle: 'normal',
          textColor: [0, 0, 0],
        },
      },
      theme: 'grid',
      showHead: 'everyPage',
      headStyles: {
        halign: 'left',
        valign: 'middle',
        cellPadding: 12,
        fontSize: 18,
        minCellHeight: 36,
        fillColor: [182, 222, 254],
        textColor: [0, 0, 0],
        fontStyle: 'bold',
        font: 'Roboto',
        lineWidth: 0.6,
      },
    })

    autoTable(doc, {
      margin: { top: 180, left: 30, right: 30, bottom: 40 },
      alternateRowStyles: {
        fillColor: [255, 255, 255],
      },
      columns: pdfColumns,
      body: reportData,
      columnStyles: {
        0: {
          halign: 'left', fontSize: 14, minCellHeight: 36,
          cellPadding: 6,
          valign: 'middle',
          minCellWidth: 37,
          font: 'Roboto',
          textColor: [0, 0, 0],
          fontStyle: 'normal',
        },
        1: {
          halign: 'left',
          fontSize: 14,
          minCellHeight: 36,
          cellPadding: 6,
          valign: 'middle',
          minCellWidth: 37,
          font: 'Roboto',
          textColor: [0, 0, 0],
          fontStyle: 'normal',
        },
        2: {
          halign: 'right',
          fontSize: 14,
          minCellHeight: 36,
          cellPadding: 6,
          valign: 'middle',
          minCellWidth: 37,
          font: 'Roboto',
          textColor: [0, 0, 0],
          fontStyle: 'normal',
        },
        3: {
          halign: 'right',
          fontSize: 14,
          minCellHeight: 36,
          cellPadding: 6,
          valign: 'middle',
          minCellWidth: 37,
          font: 'Roboto',
          textColor: [0, 0, 0],
          fontStyle: 'normal',
        },
        4: {
          halign: 'left',
          fontSize: 14,
          minCellHeight: 36,
          cellPadding: 6,
          valign: 'middle',
          minCellWidth: 37,
          font: 'Roboto',
          textColor: [0, 0, 0],
          fontStyle: 'normal',
        },
        5: {
          halign: 'right',
          fontSize: 14,
          minCellHeight: 36,
          cellPadding: 6,
          valign: 'middle',
          minCellWidth: 37,
          font: 'Roboto',
          textColor: [0, 0, 0],
          fontStyle: 'normal',
        },
      },
      theme: 'grid',
      showHead: 'never',
      styles: {
        lineWidth: [0, 0.2, 0, 0.6],
      },
      tableLineWidth: 0.6,
      headStyles: {
        fontSize: 16,
        fillColor: [218, 237, 254],
        textColor: [0, 0, 0],
        cellPadding: 6,
        valign: 'middle',
        fontStyle: 'normal',
        minCellHeight: 36,
        font: 'Roboto',
      },
      didParseCell: (data) => {
        if (data.row.section === 'head') {
          if (['number', 'quantity', 'currency'].indexOf(data.column.raw.xlCol.dataType) !== -1) {
            data.cell.styles.halign = 'right'
          } else {
            data.cell.styles.halign = 'left'
          }
        }
        drawCell(data)
      },
      willDrawCell: (data) => {
        if (data.row.raw.isTableHeader) {
          doc.setFillColor(191, 225, 255)
          doc.setTextColor(0, 0, 0)
          doc.setFontSize(16).setFont('Roboto', 'normal')
          data.cell.styles.valign = 'middle'
        } else if (data.row.raw.isSubHeading) {
          doc.setFillColor(191, 225, 255)
          doc.setTextColor(0, 0, 0)
          doc.setFontSize(16).setFont('Roboto', 'normal')
          data.cell.styles.valign = 'middle'
        } else if (data.row.raw.isHeading) {
          doc.setFillColor(218, 237, 254)
          doc.setTextColor(0, 0, 0)
          doc.setFontSize(16).setFont('Roboto', 'normal')
          data.cell.styles.valign = 'middle'
        } else if (data.row.raw.isTotalRow) {
          doc.setFillColor(238, 238, 238)
          doc.setTextColor(0, 0, 0)
          doc.setFontSize(16).setFont('Roboto', 'normal')
        } else if (data.row.raw.isSubTotalRow) {
          doc.setFillColor(238, 238, 238)
          doc.setTextColor(0, 0, 0)
          doc.setFontSize(16).setFont('Roboto', 'normal')
          if (data.row.raw.value === 'LESS COMISSION') {
            doc.setTextColor(255, 0, 0)
          }
        }
      },
      didDrawPage: function (data) {
        doc.setTextColor(0, 0, 0)
        doc.setFontSize(18)
        doc.setFont('Roboto', 'bold')
        doc.text(`Report View: Detailed`, 916, 170)
        doc.setFontSize(18)
        doc.setFont('Roboto', 'bold')
        doc.text(`Booking Date :${moment(fromDate).format('DD-MMM-YYYY')} To ${moment(toDate).format('DD-MMM-YYYY')}`, 30, 170)
        doc.setTextColor(40)
        doc.addImage('/images/logo-66.png', 'JPEG', 30, 50, 50, 50)
        doc.setFontSize(26).setFont('Roboto', 'bold')
        doc.setTextColor(16, 79, 162)
        doc.text('Cargo System | Generate Hisab Report', 30 + 60, 80)
        doc.setTextColor(0, 0, 0)
        doc.setFontSize(22).setFont('Roboto', 'bold')
        doc.text(`Company Name : _Maven Tech Services Pvt. Ltd.`, doc.internal.pageSize.width - data.settings.margin.left, 80, 'right')
        jsPdfHeaderFooter(data, loginData, totalPagesExp)
        // jsPdfHeaderFooter(data,loginData, totalPagesExp)
      },
    })
    doc.setFont('Roboto')
    if (typeof doc.putTotalPages === 'function') {
      doc.putTotalPages(totalPagesExp)
    }
    if (isSave) {
      doc.save(`Own ${'Booking'} Report ${currentDateTime}.pdf`)
      setTimeout(() => {
        setState({ ...state, generatePDF: false, load: true })
        const pdfUrl = doc.output('bloburl')
        document.getElementById('hisabReportDetailed').data = pdfUrl
        // document.getElementById('hisabReportDetailed').data = doc.output('datauristring', 'GenerateHisab Detailed Report')
        focusElemnt("HisabBackBtn")
      }, 2000)

    }
    setTimeout(() => {
      setState({ ...state, generatePDF: false, load: true })
      const pdfUrl = doc.output('bloburl')
        document.getElementById('hisabReportDetailed').data = pdfUrl
      // document.getElementById('hisabReportDetailed').data = doc.output('datauristring', 'GenerateHisab Detailed Report.pdf')
      focusElemnt("HisabBackBtn")
    }, 2000)

  }
  return (
    <>
      <Box sx={{ ...sx.reportFlex, justifyContent: 'space-between', alignItems: 'center', marginTop: '10px' }}>
        <Typography variant="h5" display="block" sx={{ fontWeight: 600, color: '#444' }}>
          Report For: Generate Hisab Report
        </Typography>
        <Box sx={{ display: 'flex', flexWrap: 'wrap', gap: '10px', alignItems: 'center' }} className="itemButtons">
          {isPdfLoading ? (
            <>
              <Item sx={sx.itemsx} className="disabled-wrapper" onKeyDown={(e) => navigation3(e, "HisabGeneratePdfBtn", 'SplitBtn', () => { })}>
                <ReactHtmlTableToExcel
                  id="test-table-xls-button"
                  className="receiveitemExcelBtn"
                  table="table-to-xls"
                  filename={`GenerateHisab Detailed Report ${currentDateTime}`}
                  sheet="tablexls"
                  buttonText="Export to Excel"
                />
              </Item>
              <Item sx={sx.itemsx} className="disabled-wrapper">
                <Button
                  id='HisabGeneratePdfBtn'
                  variant="outlined"
                  sx={{ width: '100%' }}
                  className="receiveitembtn"
                  onClick={() => {
                    generatepdf(true)
                  }}
                  onKeyDown={(e) => navigation3(e, "HisabGeneratePrintBtn", "test-table-xls-button", () => { generatepdf(true) })}
                >
                  Export As PDF
                </Button>
              </Item>
              <Item sx={sx.itemsx} className="disabled-wrapper">
                <Button
                  id='HisabGeneratePrintBtn'
                  variant="outlined"
                  sx={{ width: '100%' }}
                  className="receiveitembtn"
                  onClick={() => {
                    generatepdf(false)
                  }}
                  onKeyDown={(e) => navigation3(e, "fromDate", "HisabGeneratePdfBtn", () => { generatepdf(false) })}
                >
                  Print
                </Button>
              </Item>
            </>
          ) : (
            <Item sx={sx.itemsx} className="disabled-wrapper">
              <Button id='HisabBackBtn' variant="outlined" sx={{ width: '100%' }} className="receiveitembtn" onClick={() => setIsPdfLoading(true)} onKeyDown={(e) => navigation3(e, 'fromDate', 'SplitBtn', () => { setIsPdfLoading(true); focusElemnt('SplitBtn') })}>
                Back
              </Button>
            </Item>
          )}
        </Box>
      </Box>
      {isPdfLoading ? (
        <>
          <Stack sx={{ marginLeft: 2, marginRight: 2, height: 480, paddingTop: '10px' }}>
            <TableContainer style={{ border: '1px solid #aeaeae', borderRadius: '12px' }} className="scroll">
              <Table className="table1 table-Report" size="small" aria-label="a dense table">
                {reportData?.length < 1 ? (
                  <>
                    <TableBody>
                      <TableRow>
                        <TableCell colSpan={6}>
                          <div
                            style={{
                              display: 'flex',
                              justifyContent: 'center',
                              marginTop: '20px',
                              marginBottom: '20px',
                              color: 'red',
                              fontSize: '12px',
                              lineheight: '16px',
                              letterspacing: '0.24px',
                            }}
                          >
                            <span>No results found. Please refine your search parameters and search again.</span>
                          </div>
                        </TableCell>
                      </TableRow>
                    </TableBody>
                  </>
                ) : reportData?.length >= 1 ? (
                  <TableBody
                    className="filter-data-row"
                    style={{
                      textAlign: 'center',
                      fontSize: '12px',
                      lineheight: '16px',
                      letterspacing: '0.24px',
                      fontWeight: '500',
                      marginLeft: '5px',
                    }}
                  >
                    {reportData?.map((item, index) => (
                      <SecontInsideRowContent item={item} index={index} key={index} />
                    ))}
                  </TableBody>
                ) : (
                  ''
                )}
              </Table>
              <Table style={{ display: 'none' }} id="table-to-xls" className="table1 table-Report" size="small" aria-label="a dense table">
                <TableHead style={{ display: 'none', fontWeight: 'bold' }}>
                  <TableRow>
                    <TableCell className="reportTD" style={{ fontSize: '24px', fontWeight: '500', textAlign: 'left' }} colSpan={3}>
                      <h3>Report For: Generate Hisab Report</h3>
                    </TableCell>
                    <TableCell className="reportTD" style={{ fontSize: '24px', fontWeight: '500', textAlign: 'right' }} colSpan={3}>
                      <h3>Company Name : _Maven Tech Services Pvt. Ltd.</h3>
                    </TableCell>
                  </TableRow>
                  <TableRow>
                    <TableCell colSpan={6}></TableCell>
                  </TableRow>
                  <TableRow style={{ color: 'white' }}>
                    <TableCell
                      className="ReportItemHead"
                      style={{ backgroundColor: '#BFE1FF', color: '#444', fontSize: '20px', fontWeight: '600', textAlign: 'left' }}
                      colSpan={6}
                    >
                      Vehicle No.
                    </TableCell>
                  </TableRow>
                  <TableRow>
                    <TableCell
                      className="reportTD"
                      style={{ fontWeight: 'bold', fontSize: '20px', fontWeight: '500', textAlign: 'left' }}
                      colSpan={6}
                    >
                      {vehicleNo?.VehicleNo}
                    </TableCell>
                  </TableRow>
                  <TableRow>
                    <TableCell colSpan={6}></TableCell>
                  </TableRow>
                </TableHead>
                {reportData?.length < 1 ? (
                  <>
                    <TableBody>
                      <TableRow>
                        <TableCell colSpan={6}>
                          <div
                            style={{
                              display: 'flex',
                              justifyContent: 'center',
                              marginTop: '20px',
                              marginBottom: '20px',
                              color: 'red',
                              fontSize: '12px',
                              lineheight: '16px',
                              letterspacing: '0.24px',
                            }}
                          >
                            <span>No results found. Please refine your search parameters and search again.</span>
                          </div>
                        </TableCell>
                      </TableRow>
                    </TableBody>
                  </>
                ) : reportData?.length >= 1 ? (
                  <TableBody
                    className="filter-data-row"
                    style={{
                      textAlign: 'center',
                      fontSize: '12px',
                      lineheight: '16px',
                      letterspacing: '0.24px',
                      fontWeight: '500',
                      marginLeft: '5px',
                    }}
                  >
                    {reportData?.map((item, index) => (
                      <SecontInsideRowContentForExcel item={item} index={index} key={index} fontVal={'20px'} />
                    ))}
                  </TableBody>
                ) : (
                  ''
                )}
              </Table>
            </TableContainer>
          </Stack>
        </>
      ) : (
        <>
          {generatePDF ? <div className={'generatePDF'}>Generating PDF....</div> : ''}
          {load ? (
            <object
              id="hisabReportDetailed"
              type="application/pdf"
              width="100%"
              height="440"
              title="MTLPL -Cargo System - GenerateHisab Detailed Report"
              aria-label="MTLPL -Cargo System - GenerateHisab Detailed Report"
            ></object>
          ) : (
            ''
          )}
        </>
      )}
    </>
  )
}

export default DetailedReport
